import React, { FC } from 'react';
import { FullHeightLoader } from '../../../common';
import styles from './GalleryLoadingIndicator.scss';

export const GalleryLoadingIndicator: FC = () => <FullHeightLoader className={styles.indicator} />;
